import React, { useState } from 'react';
import { Button, Input, InputNumber } from 'antd';
import { CloseOutlined, MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { useTipContext } from '../TipContextProvider';

import styles from './index.module.scss';

export default function SplittingTheBill(): React.ReactElement {
  const [selectedValue, setSelectedValue] = useState<string | undefined>();
  const { tipAmount, totalAmount } = useTipContext();
  const [count, setCount] = useState<number>(1);

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <h3>Are you splitting the bill?</h3>
      </div>
      <div>
        <span>Number of people</span>
        <div className={styles.counter}>
          <Button
            className={styles.button}
            onClick={() => setCount((prev) => Math.max(prev - 1, 0))}
            icon={<MinusOutlined />}
            disabled={count <= 1} //  Disable when count is at minimum
          />
          <InputNumber
            className={styles.input}
            min={1}
            max={10}
            value={count}
            controls={false}
            onChange={(value) => setCount(value || 1)}
          />
          <Button
            className={styles.button}
            onClick={() => setCount((prev) => prev + 1)}
            icon={<PlusOutlined />}
            disabled={count === 10}
          />
        </div>
      </div>
      <div className={styles.itemInput}>
        <span className={styles.label}>Tip per person:</span>
        <div
          className={styles.input}
          style={{ color: 'black', textAlign: 'center' }}
        >
          ${(tipAmount / count).toFixed(2)}
        </div>
      </div>
      <div className={styles.total}>
        <span>TOTAL PER PERSON: </span>
        <div className={styles.totalValue}>
          ${(totalAmount / count).toFixed(2)}
        </div>
      </div>
    </div>
  );
}
